var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Goto } from './base';
import { bridge } from '@funny/bridge';
import { getQuery, env } from '@funny/env';
var ChangbaGoto = /** @class */ (function (_super) {
    __extends(ChangbaGoto, _super);
    function ChangbaGoto() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChangbaGoto.prototype.giftHandbook = function (params) {
        this.redirectTo('//changba.com/njwap/yunying/activity2023/gift-illustrations/index/main', params);
    };
    ChangbaGoto.prototype.activityCenter = function (params) {
        this.redirectTo('//changba.com/njwap/client/activity-center/index/main', params);
    };
    ChangbaGoto.prototype.baofangMall = function (params) {
        this.redirectTo('//changba.com/njwap/baofang/mall/index/main', params);
    };
    ChangbaGoto.prototype.luboMall = function (params) {
        this.redirectTo('//changba.com/njwap/chanpin/home-mall/index/main', params);
    };
    ChangbaGoto.prototype.profile = function (userId, subTub, closeBeforePage) {
        if (subTub === void 0) { subTub = 1; }
        if (closeBeforePage === void 0) { closeBeforePage = true; }
        var url = "changba://?ac=personalpage&index=".concat(subTub, "&userid=").concat(userId);
        bridge.openPage(url, closeBeforePage);
    };
    ChangbaGoto.prototype.topUp = function (isHalf, closeBeforePage) {
        if (isHalf === void 0) { isHalf = true; }
        if (closeBeforePage === void 0) { closeBeforePage = true; }
        var url = "changba://?ac=mycoins&is_show_half=".concat(isHalf ? '1' : '0');
        bridge.openPage(url, closeBeforePage);
    };
    ChangbaGoto.prototype.soloRecordCover = function (songId) {
        var refSrc = getQuery('refsrc') || 'none';
        var isAndroid = env.browser.isAndroid;
        var ac = isAndroid ? 'record' : 'marketrecord';
        // INFO: 安卓不要关页面，iOS要关页面，因为端的实现行为不一致
        bridge.openPage("changba://?ac=".concat(ac, "&songid=").concat(songId, "&orderid=&clksrc=").concat(refSrc), !isAndroid);
    };
    ChangbaGoto.prototype.memberCenter = function () {
        bridge.openPage("changba://?ac=membercenter");
    };
    ChangbaGoto.prototype.trendDetailPage = function (trendid) {
        bridge.openPage("changba://?ac=trenddetails&trendid=".concat(trendid));
    };
    ChangbaGoto.prototype.musicBoardPage = function () {
        bridge.openPage("changba://?ac=musicboard");
    };
    ChangbaGoto.prototype.squarePage = function () {
        bridge.openPage("changba://?ac=timeline&index=0&tabname=0");
    };
    ChangbaGoto.prototype.searchfamilyPage = function (familysearchkey) {
        bridge.openPage("changba://?ac=searchfamily&familysearchkey=".concat(familysearchkey));
    };
    return ChangbaGoto;
}(Goto));
export { ChangbaGoto };
